import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, CardBody, CardTitle, Row, Col, Badge, Table } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import NumberCommas from "../../../Components/NumberCommas/NumberCommas";
import PaymentLogServices from "../../../Services/QRCodeServices/PaymentLogServices/PaymentLogServices";

const PaymentDetail = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchDetail = async () => {
    try {
      const response = await PaymentLogServices.detail(id);
      setData(response);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching payment details:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDetail();
  }, [id]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!data) {
    return <div className="text-center mt-5">No payment found</div>;
  }

  // Format payment date
  const formattedDate = new Date(data.paymentDate).toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb
          pageTitle="Payment"
          title="Payment Detail"
          breadcrumbItems={[{ title: "Back To List", link: "/payment" }]}
        />

        <Card className="shadow-sm">
          <CardBody>
            <Row>
              <Col md={12}>
                <Row>
                  <Col md={6} className="mb-3">
                    <h5 className="text-muted">Supplier Name</h5>
                    <h4 className="fw-bold">
                      <Badge color="light" className="text-dark">
                        {data.supplierName}
                      </Badge>
                    </h4>
                  </Col>
                  <Col md={6} className="mb-3">
                    <h5 className="text-muted">Paid Amount</h5>
                    <h4 className="fw-bold">
                      <Badge color="light" className="text-dark">
                        <NumberCommas number={data.paidAmount} />
                      </Badge>
                    </h4>
                  </Col>
                </Row>

                <hr />

                <Row>
                  <Col md={6} className="mb-3">
                    <h5 className="text-muted">Invoice ID</h5>
                    <p>{data.invoiceId}</p>
                  </Col>
                  <Col md={6} className="mb-3">
                    <h5 className="text-muted">Payment Date</h5>
                    <p>{formattedDate}</p>
                  </Col>
                </Row>

                <Row>
                  <Col md={6} className="mb-3">
                    <h5 className="text-muted">Payment Method</h5>
                    <p>
                      <Badge color="info">{data.paymentMethod}</Badge>
                    </p>
                  </Col>
                  <Col md={6} className="mb-3">
                    <h5 className="text-muted">Remarks</h5>
                    <p>{data.remarks || "No remarks available"}</p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default PaymentDetail;
